export * from "./helpers";
export * from "./propsInterface";
export * from "./utils";

export const UserRole: any = {
  Administrator: "ADMINISTRATOR",
  Default: "USER",
  SuperUser: "SUPER USER",
  User: "USER",
  AutoUser: "AUTO USER",
  Volunteer: "VOLUNTEER",
  VolunteerLead: "VOLUNTEER LEAD",
  VolunteerSenior: "VOLUNTEER SENIOR"
};
